module.exports = __webpack_public_path__ + "static/media/2019-07-18.9eeb40a6.md";